export default __webpack_public_path__ + "static/media/stopActive.8f4e5685.svg";